<template>
  <div class="nav-background">

     <!--------------------------full size menu----------------------------->
     <v-app-bar
         v-if="!hamburger_menu"
         :app="app_val"
         id="site-menu"
         elevation="0"
         :dark="dark"
         dense
     >

        <div
            v-for="(item, i) in items"
            :key="i">

           <!---------- submenu --------------------------------->
           <template v-if="item.sub_items">

              <v-menu offset-y open-on-hover >
                 <template v-slot:activator="{ on, attrs }">
                    <v-btn text    v-bind="attrs" v-on="on">
                       {{ item.name }}
                    </v-btn>
                 </template>

                 <div>
                    <div
                        v-for="(subitem, i) in item.sub_items"
                        :key="'sub'+i"
                        class="link-box"
                    >

                       <!--<v-btn :to="subitem.to" :href="subitem.href">-->
                       <!--   {{subitem.name}}-->
                       <!--</v-btn>-->

                       <router-link v-if="subitem.to"
                                    :to="subitem.to" class="link" :target="subitem.target">
                          <div style="width: 100%">
                             {{subitem.name}}
                          </div>

                       </router-link>
                       <a v-else
                          :href="subitem.href" class="link" :target="subitem.target"
                       >
                          <div style="width: 100%">
                             {{subitem.name}}
                          </div>
                       </a>
                    </div>


                 </div>
              </v-menu>
           </template>



           <!-----------render basic button--------------------->
           <template v-else>
              <v-btn
                  v-if="item.to"
                  text
                  :to="item.to"
              >
                 <span >{{ item.name }}</span>
              </v-btn>

              <v-btn
                  v-else
                  text
                  :href="item.href"
              >
                 <span >{{ item.name }}</span>
              </v-btn>
           </template>

        </div>


        <v-spacer/>

        <v-btn text @click="jp_mode">日本語 (Japanese)</v-btn>

     </v-app-bar>












    <!--------------------------hamburger menu----------------------------->
    <v-app-bar
            v-else
            :app="app_val"
            id="site-menu"
            elevation="0"
            :dark="dark"


    >
      <!--<a href="/">-->
        <!--<img src="../assets/images/logo/espy-logo-dark-bg.svg" width="200px">-->
      <!--</a>-->

      <!--<span class="pa-3"></span>-->

      <v-spacer></v-spacer>

      <v-menu
              bottom
              origin="center center"
              transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn
                  icon
                  v-on="on"
          >
            <v-icon>menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
          >
            <v-list-item-title>
              <v-btn v-if="item.url" text :to="item.url">{{ item.name }}</v-btn>
              <v-btn v-else text :href="item.href">{{ item.name }}</v-btn>
              </v-list-item-title>
          </v-list-item>


        </v-list>
      </v-menu>
    </v-app-bar>






  </div>

</template>


<style scoped>
/*.nav-background{*/
/*    background-color: #3d53bb;*/
/*}*/

  #site-menu{
  background: none;
  /*   background-color: #2196F3;*/
  }

  /*.link-active{*/
  /*  background-color: #2196F3;*/
  /*}*/



  .link-box{
      padding: 5px 10px 5px 10px;
      background-color: white;
  }
  .link-box:hover{
      background-color: var(--color-highlight-primary);
  }

  .link{
      text-decoration: none;
      color: #3e3e3e;
      font-weight: 500;
      font-size: 14pt;
  }



</style>
<script>
export default {
  name: 'NavBarEn',
   props:{
     app: Boolean,
      dark: {type: Boolean, default: false}
   },

  data: () => ({
     show_menu: false,

     items: [
        {name: 'Home', to: '/'},
        {
           name: 'Radio',
           sub_items: [
              {name: 'Radio Schedule', to: '/radio'},
              {name: 'Living The Bible', to: '/radio/living-the-bible'},
              {name: 'Living The Bible Short', to: '/radio/living-the-bible-q'},
           ]
        },
        {name: 'Music', to: '/music'},
        {
           name: 'Videos', to: '/video',
           sub_items:[
              {name: 'Namihira Story', to: '/video/namihira-story'},
              {name: 'Church Content', to: '/video/namihira-church'},
              {name: 'What in the world are they spraying?', href: 'https://www.youtube.com/watch?v=6UuTRRuVLKs', target: '_blank'},
           ]
        },
        {
           name: 'Documents',
           sub_items:[
              {name: 'Fall Seven Times, Get Up Eight',
                 href: 'https://totalhealthfoundation.nyc3.digitaloceanspaces.com/en/misc/FALL%20DOWN%20SEVEN%20(7)%20TIMES,%20GET%20UP%20EIGHT%20(8).pdf',
                 target: '_blank'},
              
           ]
        },
        
        {name: 'Links', to: '/links'},
        {name: 'Contact', to: '/contact'},
        {name: 'About Us', to: '/aboutus'},


     ]

  }),
   methods:{
      toggle_menu(){
         if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)){
            this.show_menu=false;
            return;
         }

         this.show_menu = !this.show_menu;
      },

      jp_mode(){
         this.$store.commit('update_lang', 'jp');
         this.$router.push('/jp/home');
      },

   },

   computed:{


     hamburger_menu(){
        return (['xs', 'sm'].includes(this.$vuetify.breakpoint.name));
     },

      app_val()
      {
         if (this.app !== undefined)
            return this.app;
         else return false;
      }
   },

   created(){
     // console.log(this.$vuetify.breakpoint)

     console.log('baseurl', window.location)

   }
};
</script>
